/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from "react";
import { useAppSelector } from "../../../../infra/hooks";

interface PropsValues {
  setOffboardingData: (data: any) => void;
}

function DTOOffBoardingWorkflow({ setOffboardingData }: PropsValues) {
  const selector = useAppSelector((state) => state);
  const storedOffboarding: any = selector.offBoardingListSlice.offBoardingList;

  useEffect(() => {
    setOffboardingData(storedOffboarding);
  }, []);

  useEffect(() => {
    setOffboardingData(storedOffboarding);
  }, [storedOffboarding]);

  return <></>;
}
export default DTOOffBoardingWorkflow;
